import React from 'react';
import { Link, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import AdminContentManager from './AdminContentManager';
import AdminNewsManager from './AdminNewsManager';
import AdminWorkManager from './AdminWorkManager';

const adminSections = [
  {
    key: 'work',
    label: 'Work',
    path: '/admin/work'
  },
  {
    key: 'news',
    label: 'News',
    path: '/admin/news'
  },
  {
    key: 'cv',
    label: 'CV',
    path: '/admin/cv'
  },
  {
    key: 'notice',
    label: 'Contact',
    path: '/admin/notice'
  }
];

class Admin extends React.Component {
  componentDidMount() {
    const accessToken = localStorage.getItem('access_token');
    const expiresAt = Number(localStorage.getItem('expires_at'));
    const currentEpoch = Math.floor(Date.now() / 1000);

    if (!accessToken || !expiresAt || expiresAt <= currentEpoch) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('refresh_token_expires_at');
      this.props.history.replace('/admin/login');
    }
  }

  logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('refresh_token_expires_at');
    this.props.history.replace('/work');
  }

  render() {
    return (
      <div className="admin-shell">
        <header className="admin-header">
          <div>
            <h1 className="admin-header-title">PyovsPyo Admin</h1>
          </div>
          <div className="admin-header-actions">
            <Link className="admin-header-link" to="/work">사이트로 이동</Link>
            <button type="button" className="admin-header-logout" onClick={this.logout}>로그아웃</button>
          </div>
        </header>

        <div className="admin-toolbar">
          <div className="admin-toolbar-title">수정할 항목</div>
          <nav className="admin-nav">
            {adminSections.map((section) => {
              const isActive = this.props.location.pathname === section.path;

              return (
                <Link
                  key={section.key}
                  className={`admin-nav-link${isActive ? ' active' : ''}`}
                  to={section.path}
                >
                  <span className="admin-nav-label">{section.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <main className="admin-content">
          <Switch>
            <Route exact path="/admin">
              <Redirect to="/admin/work" />
            </Route>
            <Route path="/admin/work">
              <AdminWorkManager />
            </Route>
            <Route path="/admin/cv">
              <AdminContentManager
                contentType="R"
                title="CV"
                description="CV 섹션의 프로필, 경력, 스킬 정보를 관리하는 영역입니다."
              />
            </Route>
            <Route path="/admin/news">
              <AdminNewsManager />
            </Route>
            <Route path="/admin/notice">
              <AdminContentManager
                contentType="C"
                title="Contact"
                description="Contact 섹션의 연락처 정보와 안내 문구를 편집하는 영역입니다."
              />
            </Route>
          </Switch>
        </main>
      </div>
    );
  }
}

export default withRouter(Admin);
